import React, { Component } from 'react';
import '../adminDash.css';
import withNavigate from '../../Global_files/WithNavigate';
// import Customericon from '../../assets/customer-icon.png';
// import Editicon from '../../assets/icons8-edit.png';
// import Deleteicon from '../../assets/icons8-trash-50.png';
import {  get, patch, getFreshToken, post} from '../../custom_libraries/serverRequests';
import { Switch, Button } from '@mui/material/';
import urls from '../../custom_libraries/urls';
import globalVariables from '../../custom_libraries/globalVariables';
import Alert from "@mui/material/Alert";
import CheckIcon from "@mui/icons-material/Check";
// import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
// import CloudQueueIcon from '@mui/icons-material/CloudQueue';
import { Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
//-------------dark theme-------------------------------------
import { createTheme, ThemeProvider } from "@mui/material/styles"; //MUI dark theme using ThemeProvider
import CssBaseline from "@mui/material/CssBaseline";

const darkTheme = createTheme({
  palette: {
    mode: "dark",
    background: {
      // default: "#0d0d0d",
      // paper: "#000000",
      default: "#191e29",
      paper: "#212632",
    },
    text: {
      primary: "#ffffff",
      secondary: "#bbbbbb",
    },
  },
});
//------------------------------------------

class UserPermissions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user_list: [],
            searchInput: '',
            currentPage: 1,
            rowsPerPage: 15,
            // toggleStates: {}, // Tracks both "Is Admin" and "Is Client" states for each user_id
            userType:'',
            post_user_info:{},
            is_checked:false,
            userId:'',
            error1:false,
            success2:false,
            error2: false,
            dealerUserInfo: {},
            dealerCloudToggles: {},
            cloud_storage_status:false,
            password_visibility: false,
        };
    }

    componentDidMount() {
        setTimeout(() => {
            this.validateSignedIn();
          }, 0);
        this.getUsersList();
        this.getDealerUserInfo();
    }

    validateSignedIn = async () => {
        try {
          let is_fresh_token = await getFreshToken();
          console.log("Fresh Token:", is_fresh_token);

          if (!is_fresh_token) {
            console.log("Navigating to login...");
            this.props.navigate("/");
            return;
          }
        } catch (error) {
          console.error("Error in validateSignedIn:", error);
        }
      }

    componentDidUpdate(prevProps, prevState) {
        if (
            this.state.error1 !== prevState.error1 ||
            this.state.success2 !== prevState.success2 ||
            this.state.error2 !== prevState.error2
        ) {
            if (
                this.state.error1 ||
                this.state.success2 ||
                this.state.error2
            ) {
                setTimeout(() => {
                    this.setState({
                        error1: false,
                        success2: false,
                        // error2:false
                    });
                }, 3000); // 4.5 second

                setTimeout(() => {
                    this.setState({
                        error2:false
                    });
                }, 5500); // 4.5 second
            }
        }
    }

    getUsersList = async () => {
        try {
            let access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);
            let dealer_id= localStorage.getItem(globalVariables.USER_ID);
            let headers = {
                'content-type': 'application/json',
                'Authorization': `Bearer ${access_token}`
            }
           let url = urls.GET_USER_LIST_WITH_PERMISSIONS(dealer_id);
            const response = await get(urls.GET_USER_LIST_WITH_PERMISSIONS(dealer_id), headers); // API call
            // Validate the response and extract results
            if (!response || !response.data || !Array.isArray(response.data)) {
                console.error("Invalid response or results:", response);
                this.setState({ user_list: [] });
                return;
            }
            this.setState({ user_list: response.data });
        } catch (error) {
            console.error("Error in getUsersList:", error);
            this.setState({ user_list: [] });
        }
    };

    handleChangePage = (newPage) => {
        this.setState({ currentPage: newPage });
    };

    handleSearchInputChange = (e) => {
        this.setState({ searchInput: e.target.value, currentPage: 1 });  // reset page on search
      };

    // handleToggle = (user_id, toggleType, isChecked) => {
    //     this.setState((prevState) => ({
    //         user_list: prevState.user_list.map((user) =>
    //             user.user_id === user_id
    //                 ? { ...user, user_type: isChecked ? toggleType : "" } // Update user_type based on toggle
    //                 : user
    //         ),
    //         userType: toggleType,
    //         userId: user_id,
    //         is_checked : isChecked
    //     }), () => {
    //         console.log("Updated user_list:", this.state.user_list);
    //         console.log ("handleToggle------", user_id, toggleType, isChecked);
    //     });
    // };

    handleToggle = (user_id, toggleType, isChecked, toggleSource = "role") => {
      this.setState((prevState) => {
        const updatedUserList = prevState.user_list.map((user) => {
          if (user.user_id !== user_id) return user;

          // Update the correct field, but retain the other field
          if (toggleSource === "cloud") {
            return {
              ...user,
              cloud_storage_status: isChecked,
            };
          }else if (toggleSource === "password_visibility") {
            return {
              ...user,
              password_visibility: isChecked,
            };
          }
           else {
            return {
              ...user,
              user_type: isChecked ? toggleType : "",
            };
          }
        });

        return {
          user_list: updatedUserList,
          userId: user_id,
          is_checked: isChecked,
          userType: toggleSource === "role" ? toggleType : prevState.userType,
        };
      }, () => {
        console.log("Updated user_list:", this.state.user_list);
      });
    };


    handleUpdateUserPermissions = async (userType) => {
        const {userId, is_checked, user_list } = this.state;
        try {
            let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)

            let headers = {
                'content-type': 'application/json',
                'Authorization': `Bearer ${access_tocken}`
            }

            const selectedUser = user_list.find(u => u.user_id === userId);
            if (!selectedUser) {
              console.warn("User not found in user_list");
              return;
            }

            console.log("------user_id in update user permission-----", userId, userType);
            const url = urls.USER_DETAILS(userId);  // static method defined in urls.jsx: passed the deviceId of selected device (device row)      const response = await get(url);

            const response = await get(url, headers); // Perform the API call using the constructed URL

            // console.log(`API Response for LoadSelectedUserInfo ${userId}:`, response);
            let data = response.data

            if (data && Object.keys(data).length > 0) {
                console.log(`API Response for LoadSelectedUserInfo ${userId}:`, data);
                let post_data = {
                    "user_id": userId,
                    "first_name":data[0].first_name,
                    "last_name": data[0].last_name,
                    "phoneno": data[0].phoneno,
                    "email": data[0].email,
                    "is_active": data[0].is_active,
                    "user_type": selectedUser.user_type,
                    "cloud_storage_status": selectedUser.cloud_storage_status,
                    "password_visibility": selectedUser.password_visibility
                    }
                    console.log("----post_data----", post_data);

                    post_data = JSON.stringify(post_data)

                    // console.log("---is checked----", is_checked);

                // if (is_checked){
                    let response = await patch(urls.UPDATE_USER_DEATILS(userId), post_data, headers)
                    if (response.data && response.data.length > 0) {
                        // alert("Site updated successfully.");
                        this.setState({
                            success2: true
                        })
                        setTimeout(() => {
                            this.getUsersList();
                        }, 2000);
                    }
                // }
                else {
                    // alert("Error updating site. Please try again.");
                    this.setState({
                        error2: true
                    })
                }

            }
        } catch (error) {
            console.error("Error fetching cameras from API:", error);
            // this.setState({ cameras: [] }); // Clear the cameras list in case of error
        }
    }

  getDealerUserInfo = async () => {
  try {
    const dealerId = localStorage.getItem(globalVariables.USER_ID);
    const access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);

    const headers = {
      'content-type': 'application/json',
      'Authorization': `Bearer ${access_token}`
    };

    const url = urls.GET_ADMIN_LIST_WITH_PERMISSIONS(dealerId);
    const response = await get(url, headers);

    if (response && response.data) {
      const dealerInfo = response.data;

      // ✅ Extract cloud storage status (adjust key name if needed)
      const cloudStatus = dealerInfo.cloud_status === true || dealerInfo.cloud_status === "true" || dealerInfo.cloud_status === 1 || dealerInfo.cloud_status === "1";
      // localStorage.setItem(globalVariables.CLOUD_STORAGE_STATUS, dealerInfo.cloud_status);
      this.setState({
        dealerUserInfo: dealerInfo,
        adminCloudEnabled: cloudStatus
      });
    }
  } catch (error) {
    console.error("Error fetching dealer user info:", error);
  }
};


handleDealerCloudToggle = (user_id, isChecked) => {
  this.setState((prevState) => ({
    dealerCloudToggles: {
      ...prevState.dealerCloudToggles,
      [user_id]: isChecked,
    },
  }));
};

saveDealerCloudSetting = (user_id) => {
  const isCloudEnabled = this.state.dealerCloudToggles[user_id];
  console.log(`Mock Save: User ${user_id}, Cloud Storage Enabled: ${isCloudEnabled}`);

  this.setState({ success2: true });
  setTimeout(() => this.setState({ success2: false }), 3000);
};

postCloudStorageStatus = async (isEnabled) => {
  try {
    const dealerId = localStorage.getItem(globalVariables.USER_ID); // This is your user_id
    const token = localStorage.getItem(globalVariables.AUTH_TOKEN);

    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    };

    const data = {
      user_id: dealerId,
      status: isEnabled
    };

    const url = urls.SET_CLOUD_STORAGE_STATUS; // Use from urls.jsx

    console.log("POST data to be sent:", data);

    const response = await post(url, JSON.stringify(data), headers);

    localStorage.setItem(globalVariables.CLOUD_STORAGE_STATUS, isEnabled ? "true" : "false");
    this.setState({ success2: true });
    setTimeout(() => this.setState({ success2: false }), 3000);
  } catch (error) {
    console.error("Error posting cloud storage status:", error);
    this.setState({ error1: true });
  }
};


    render() {
        const { user_list, currentPage, rowsPerPage, searchInput, error1, success2, error2 } = this.state;

        // Filter user list based on search input
        // const filteredClientList = user_list.filter((user) =>
        //     (user.first_name && user.first_name.toLowerCase().includes(searchInput.toLowerCase())) ||
        //     (user.address && user.address.toLowerCase().includes(searchInput.toLowerCase()))
        // );

        // Filter devices based on search input
        const filteredUserList = user_list.filter((user) =>
        user.username.toLowerCase().includes(searchInput.toLowerCase())
        );

        // Calculate pagination indices
        const indexOfLastRow = currentPage * rowsPerPage;
        const indexOfFirstRow = indexOfLastRow - rowsPerPage;
        const currentRows = filteredUserList.slice(indexOfFirstRow, indexOfLastRow);
        const columnStyle = {
          padding: "12px",
          fontSize: "14px",
          color: "#333",
          borderRight: "1px solid #ddd",
        };

        const rowCellStyle = {
          padding: "12px",
          borderTop: "1px solid #eee",
          borderRight: "1px solid #eee",
          textAlign: "center",
          verticalAlign: "middle",
          backgroundColor: "#fff",
        };

        const totalPages = Math.max(1, Math.ceil(filteredUserList.length / rowsPerPage));

        return (
          <ThemeProvider theme={darkTheme}>
                  <CssBaseline />
            <div style={{ display: 'flex', flexDirection: 'column' }}>

                <div className="home-container" style={{ display: 'flex', flex: '1', overflow: 'hidden', height: '100vh', paddingLeft: '5px' }}>
                    <div style={{ flex: '5', marginLeft: '0.5%', padding: '20px', overflowY: 'auto' }}>
                        <div>
                            <div className="search-container">
                            <span>
                            {error1 ? (
                                                <Alert severity="error">Server Error! User permission was not Updated!</Alert>
                                            ) : error2 ? (
                                                <Alert severity="error">You can not disable both permissions! Please set one of the roles.</Alert>
                                            ): success2 ? (
                                                <Alert icon={<CheckIcon fontSize="inherit" />} severity="success"> User permission was updated successfully!</Alert>
                                            ) : null}
                            </span>
                                <input
                                type="text"
                                id="search-input"
                                placeholder="Search by user name"
                                value={searchInput}
                                onChange={this.handleSearchInputChange}
                                />
                            </div>


                            <div>
                            <div>
                                <table id="devices" style={{ width: "100%", minWidth: "900px", borderCollapse: "collapse", marginBottom:'15px', textAlign:'center' }}>
                                    <thead>
                                        <tr>
                                        <th> Username</th>
                                        <th> Email </th>
                                        <th>Is Technician?
                                     <Tooltip
                                        title={
                                          <>
                                            <strong>Technician Permissions:</strong>
                                            <br />• Access: System Overview, Sites, Alerts, Analytics
                                            <br />• Limited to assigned sites only
                                            <br /><br />

                                            <strong>System Overview:</strong>
                                            <br />• View camera stats (Total, Live, Offline)
                                            <br />• Monitor warnings & errors (Timezone, Offline, HDD)
                                            <br />• View logs and last 24h activity
                                            <br /><br />

                                            <strong>Sites Tab:</strong>
                                            <br />• View assigned sites & devices
                                            <br />• Mute cameras (cannot unmute)
                                            <br />• Draw ignore zones
                                            <br />• Configure schedules & camera health
                                            <br />• Manage SMTP alert emails
                                            <br />• Cannot add/delete sites or groups
                                            <br /><br />

                                            <strong>Alerts Tab:</strong>
                                            <br />• View and resolve alerts
                                            <br /><br />

                                            <strong>Analytics Tab:</strong>
                                            <br />• View analytics data
                                            <br />• Download reports
                                          </>
                                        }
                                        arrow
                                        placement="top"
                                        componentsProps={{
                                          tooltip: {
                                            sx: {
                                              backgroundColor: '#283348',
                                              color: '#fff',
                                              fontSize: '13px',
                                              border: '1px solid #99acb8',
                                            },
                                          },
                                          arrow: {
                                            sx: {
                                              color: '#283348',
                                            },
                                          },
                                        }}
                                      >
                                        <InfoOutlinedIcon
                                          style={{
                                            fontSize: "16px",
                                            marginLeft: "6px",
                                            verticalAlign: "middle",
                                            color: "#bac6d6",
                                            cursor: "pointer"
                                          }}
                                        />
                                      </Tooltip>
                                        </th>
                                        <th>Is Client?
                                          <Tooltip
                                          title={
                                            <>
                                              <strong>Customer Permissions:</strong>
                                              <br />• Access: System Overview, Settings
                                              <br /><br />

                                              <strong>System Overview:</strong>
                                              <br />• View camera stats (Total, Live, Offline)
                                              <br />• Monitor warnings & errors (Timezone, Offline, HDD)
                                              <br />• View logs and last 24h activity
                                              <br />• View device & camera error details
                                              <br /><br />

                                              <strong>Settings Tab:</strong>
                                              <br />• Configure email alerts with date & time scheduling
                                              <br />• Schedule email delivery timings
                                              <br />• Select problem types for notifications (What Info Sub Tab)
                                              <br />• Access AI Engine settings
                                              <br />• Create new recording templates
                                              <br /><br />

                                              <strong>Restrictions:</strong>
                                              <br />• No access to Sites, Alerts, or Analytics tabs
                                              <br />• Cannot manage users or permissions
                                            </>
                                          }
                                          arrow
                                          placement="top"
                                          componentsProps={{
                                            tooltip: {
                                              sx: {
                                                backgroundColor: '#283348',
                                                color: '#fff',
                                                fontSize: '13px',
                                                border: '1px solid #99acb8',
                                              },
                                            },
                                            arrow: {
                                              sx: {
                                                color: '#283348',
                                              },
                                            },
                                          }}
                                        >
                                          <InfoOutlinedIcon
                                            style={{
                                              fontSize: "16px",
                                              marginLeft: "6px",
                                              verticalAlign: "middle",
                                              color: "#bac6d6",
                                              cursor: "pointer"
                                            }}
                                          />
                                        </Tooltip>
                                        </th>
                                        {/* <th>Cloud Storage</th> */}
                                        {/* <th>Password Visibility</th> */}
                                        <th> Action </th>
                                        </tr>
                                    </thead>
                                    <tbody>

 {/* Dealer User */}
{this.state.dealerUserInfo?.user_type === "DealerUser" && (
  <tr key="dealer-row" style={{ backgroundColor: "#2d343a" }}>
    <td style={{ color: "#f8f8f8", fontWeight: "600" }}>
      {this.state.dealerUserInfo.username || "Dealer"}
    </td>
    <td style={{ color: "#f8f8f8", fontWeight: "600" }}>
      {this.state.dealerUserInfo.email || "N/A"}
    </td>
    <td>
      <Switch checked disabled size="small" />
    </td>
    <td>
      <Switch checked disabled size="small" />
    </td>
    {/* <td>
      <Switch
        checked={this.state.adminCloudEnabled}
        onChange={(e) => {
          const isEnabled = e.target.checked;
          this.setState({ adminCloudEnabled: isEnabled });
        }}
        color="primary"
        size="small"
      />
    </td> */}
    {/* <td>
      <Switch checked disabled size="small" />
    </td> */}
    <td>
      {/* <Button
        variant="contained"
        size="small"
        // onClick={() => this.postCloudStorageStatus(this.state.adminCloudEnabled)}
        style={{
          borderColor: "#055b72",
          color: "#19457d",
          fontWeight: 600,
          textTransform: "none",
          padding: "4px 10px"
        }}
      >
        Save
      </Button> */}
    </td>
  </tr>
)}

  {/* Existing user list */}
 {currentRows.map((user) => {
  return (
    <tr key={user.user_id}>
      <td>{user.username}</td>
      <td>{user.email}</td>
      <td>
        <Switch
          checked={user.user_type === "TechnicianUser"}
          onChange={(event) => this.handleToggle(user.user_id, "TechnicianUser", event.target.checked, "role")}
          name={`TechnicianUser_${user.user_id}`}
          color="primary"
          size="small"
          disabled={user.user_type === "CustomerUser"}
        />
      </td>
      <td>
        <Switch
          checked={user.user_type === "CustomerUser"}
          onChange={(event) => this.handleToggle(user.user_id, "CustomerUser", event.target.checked, "role")}
          name={`CustomerUser_${user.user_id}`}
          color="primary"
          size="small"
          disabled={user.user_type === "TechnicianUser"}
        />
      </td>

      {/* ✅ Cloud Toggle */}
      {/* <td>
        <Switch
          checked={String(user.cloud_storage_status).toLowerCase() === "true"}
          onChange={(e) =>
            this.handleToggle(user.user_id, "", e.target.checked, "cloud")
          }
          size="small"
          disabled={user.user_type === "CustomerUser"}
        />
      </td> */}

      {/* ✅ password visibility Toggle */}
      {/* <td>
        <Switch
          checked={String(user.password_visibility).toLowerCase() === "true"}
          onChange={(e) =>
            this.handleToggle(user.user_id, "", e.target.checked, "password_visibility")
          }
          size="small"
          disabled={user.user_type === "CustomerUser"}
        />
      </td> */}

      {/* ✅ Save Button for roles */}
      <td>
        <Button
          variant="contained"
          // className="permissionSave"
          sx={{
            border: '1px solid #8ff4af',
            curson: 'pointer',
            backgroundColor: '#344758',
            color:'#fff',
            "&:hover": {
              backgroundColor: "#1f5c6d",
              color: "white",
              // borderColor: "#50c66b",
            },
          }}
          onClick={() =>
            this.setState({ userId: user.user_id }, () => this.handleUpdateUserPermissions())
          }
        >
          <b>Save</b>
        </Button>
      </td>
    </tr>
  );
})}
                                        {currentRows.length === 0 && (
                                        <tr>
                                            <td colSpan="15" style={{ textAlign: "center", padding: "20px", color:'orange' }}>
                                            No user found.
                                            </td>
                                        </tr>
                                        )}
                                    </tbody>
                                </table>
                                </div>


                            </div>
                            <div style={{ marginTop: '2.2cm', display: 'flex', justifyContent: 'center', marginBottom: '2.2cm' }}>
                                <button
                                    id="rowsPerPageButton"
                                    onClick={() => this.handleChangePage(currentPage - 1)}
                                    disabled={currentPage === 1}
                                >
                                    {"< Prev"}
                                </button>&emsp;
                                <span style={{ fontSize: 'small' }}>
                                    {`Page ${currentPage} / ${totalPages}`}
                                </span>&emsp;
                                <button
                                    id="rowsPerPageButton"
                                    onClick={() => this.handleChangePage(currentPage + 1)}
                                    disabled={currentPage >= totalPages}
                                >
                                    {"Next >"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          </ThemeProvider>
        );
    }
}

export default withNavigate(UserPermissions);